// ============================================================================
// FILE: apps/frontend/src/config/contact.ts
// PURPOSE: The public support contact shown on Contact, the Privacy Policy and
// the Terms. Email: support@acodeus.com (Google Workspace, live 2026-10-10).
// Phone: the Google Voice business line (2026-10-10). Contact-form mail goes to
// CONTACT_NOTIFY_TO on the backend.
// ============================================================================

export const SUPPORT_EMAIL = "support@acodeus.com";
export const SUPPORT_PHONE = "(251) 225-4575";
export const SUPPORT_PHONE_HREF = "tel:+12512254575";
